import { Controller } from "@hotwired/stimulus"
import { Modal } from "mdb-ui-kit"
// To open modal add this controller to .modal element
// to close after submit add action close on a form
//
// <div class="modal" tabindex="-1" data-controller='mdb-modal'>
// ...
// <%= f.submit "Submit", "data-action": "click->mdb-modal#close" %>

// Back button will load the modal again since <turbo-frame> contains .modal and
// src attribute (it will again load the .modal)
// so we need to remove .modal and clear src attribute
// https://turbo.hotwired.dev/handbook/building#preparing-the-page-to-be-cached
document.addEventListener("turbo:before-cache", function () {
  // Remove modals since they will be opened automatically on connect
  const modals = document.querySelectorAll('[data-controller="mdb-modal"]')

  modals.forEach((modal) => {
    let frame = modal.closest("turbo-frame")

    if (frame) {
      // If the closest frame does NOT have src, look for its parent frame with src
      if (!frame.hasAttribute("src")) {
        const parentFrameWithSrc = frame.closest("turbo-frame[src]")
        if (parentFrameWithSrc) {
          parentFrameWithSrc.src = null
          console.log(
            `Cleared parent turbo-frame src: #${parentFrameWithSrc.id}`
          )
          return
        }
      }

      // Otherwise, clear the closest frame
      frame.innerHTML = ""
      frame.src = null
      console.log(`Cleared turbo-frame: #${frame.id}`)
    }
  })

  // Restore body scroll
  document.body.style.overflow = ""
  document.body.style.position = ""
  document.body.style.width = ""
  document.body.classList.remove("modal-open")
})

export default class extends Controller {
  static values = {
    backdrop: { type: String, default: "true" },
  }

  connect() {
    const scrollTop = window.scrollY
    const scrollLeft = window.scrollX

    document.body.style.overflow = "hidden"
    document.body.style.position = "fixed"
    document.body.style.top = `-${scrollTop}px`
    document.body.style.left = `-${scrollLeft}px`
    document.body.style.width = "100%"

    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove())
    document.body.classList.remove("modal-open")
    document.body.style.overflow = ""
    document.body.style.position = ""
    document.body.style.width = ""

    this.modal = new Modal(this.element, {
      backdrop: this.backdropValue === "static" ? "static" : true,
      keyboard: this.backdropValue !== "static",
    })

    this.modal.show()

    this.element.addEventListener("hidden.bs.modal", () => {
      document.body.style.overflow = ""
      document.body.style.position = ""
      document.body.style.top = ""
      document.body.style.left = ""
      document.body.style.width = ""
      window.scrollTo(scrollLeft, scrollTop)
    })
  }

  close() {
    if (this.element) {
      // Remove the modal itself
      this.element.classList.add("d-none")
      console.log(`Removed modal: #${this.element.id}`)
    }

    // Remove all modal backdrops
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove())

    // Restore body scroll and remove modal-open class
    document.body.classList.remove("modal-open")
    document.body.style.overflow = ""
    document.body.style.paddingRight = ""

    // Optional: restore fixed/sticky element adjustments
    document
      .querySelectorAll(".fixed-top, .fixed-bottom, .sticky-top")
      .forEach((el) => {
        el.style.paddingRight = ""
      })
  }
}
